import { model } from "@atlassiansox/bxp-content-framework";

export const uiVideo = model({
    name: "UI Video",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        loop: {
            name: "Loop",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        autoplay: {
            name: "Autoplay",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        muted: {
            name: "Muted",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        controls: {
            name: "Controls",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        poster: {
            name: "Poster",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkMimetypeGroup: ["image"]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Asset"
        },
        sources: {
            name: "Sources",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkMimetypeGroup: ["video"]
                    }
                ],
                linkType: "Asset"
            }
        }
    },
    description: "",
    displayField: "title"
} as const);
